export enum ElementType {
    Invalid = 0,
    VariableText = 1,
    Textbox = 2,
    Checkbox = 4,
    DropdownGroup = 5,
    DropdownElement = 9,
    RadioButtonGroup = 11,
    RadioButtonElement = 10,
    Table = 6,
    Row = 7,
    Cell = 8,
    Section = 12,
    Date = 13,
    Image = 14,
}
